/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ConnectedPosition } from '@angular/cdk/overlay';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  Optional,
  ViewChild,
} from '@angular/core';

import { Type } from '@gh/core-type';
import { AutocompleteLoadMoreEvent, KEY_ESCAPE } from '@gh/core-ui';
import { isNotNil } from '@gh/core-util';

import { GridFinderSource } from './grid-finder-source.directive';

@Component({
  selector: 'gh-grid-finder',
  template: require('./grid-finder.component.html'),
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridFinderComponent {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() maskedType: Type<any> | string;
  @Input() selectable: boolean = true;
  @Input() width: number = 200;

  @ViewChild('input', { static: false }) input: ElementRef;

  panelOpened = false;

  positions: ConnectedPosition[] = [{
    originX: 'end',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'top',
    offsetX: -10,
  }];

  constructor(@Optional() @Inject(GridFinderSource) private source: GridFinderSource,
              private changeDetectorRef: ChangeDetectorRef) {
    if (!source) {
      throw new Error('Source for gh-grid-finder is not defined. ' +
        'Define one of allowed sources: ghGridFinderInMemory, ghGridFinderDataSource');
    }
  }

  get debounceTime(): number {
    return this.source.debounceTime;
  }

  get masked(): boolean {
    return isNotNil(this.maskedType);
  }

  open(): void {
    this.panelOpened = true;
    this.source.onOpen();
    this.changeDetectorRef.markForCheck();
  }

  close(): void {
    this.panelOpened = false;
    this.source.onClose();
    this.changeDetectorRef.markForCheck();
  }

  onSelectRow(id: any): void {
    this.close();
    this.source.goTo(id, this.selectable);
  }

  loadMoreRows(event: AutocompleteLoadMoreEvent): void {
    event.load(this.source.loadMore(event.query));
  }

  onInputKeyDown(event: KeyboardEvent): void {
    if (event.keyCode === KEY_ESCAPE) {
      this.close();
    }
  }
}
